import React from 'react';
import { Body5 } from '@ui';
import { isAgentOutputValid } from './utils/validateAgentOutput';
import { parseAgentOutput } from './utils/parseAgentOutput';
import { AgentQAPairList } from './components/AgentQAPairList';
import { AnswerBody } from '@features/result/components/AnswerBody';

export const AgentOutput = ({ output, isStreaming = false }) => {
  if (!output) return null;

  if (!isAgentOutputValid(output)) {
    return <Body5>{output}</Body5>;
  }

  const parsed = parseAgentOutput(output);
  if (!parsed?.answer) {
    return <AnswerBody answer={output} isStreaming={isStreaming} />;
  }

  return <AgentQAPairList items={parsed.answer} isStreaming={isStreaming} />;
};
